import React, { Fragment } from 'react';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hideModal } from '../../../actions/modalActions';

const DeleteNoteModal = ({ onConfirm, onCancel }) => (
  <Fragment>
    <div className="modal-header">
      <h2 className="modal-title">Are you sure you want to clear this message?</h2>
    </div>
    <div className="modal-body">
      <p className="text-left">Any text you entered will be permanently removed.</p>
    </div>
    <div className="modal-footer">
      <div className="text-group row">
        <ButtonV2 onClick={onCancel} variant="secondary" className="btn-left">
          Cancel
        </ButtonV2>
        <ButtonV2 onClick={onConfirm} className="btn-right">
          Clear Message
        </ButtonV2>
      </div>
    </div>
  </Fragment>
);

DeleteNoteModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onConfirm: () => {
    dispatch(hideModal());
    if (ownProps.callback) ownProps.callback();
  },
  onCancel: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(DeleteNoteModal);
